import React, { Component, useState } from "react";
import { MapContainer, CircleMarker, TileLayer, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import data from "./cities";
import PiChart from "./PiChart";
import Modal from "./Modal";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

export default function GeoMap() {
    var centerLat = (data.minLat + data.maxLat) / 2;
    var distanceLat = data.maxLat - data.minLat;
    var bufferLat = distanceLat * 0.05;
    var centerLong = (data.minLong + data.maxLong) / 2;
    var distanceLong = data.maxLong - data.minLong;
    var bufferLong = distanceLong * 0.05;
    const [isShown, setIsShown] = useState(false);
    const [isActive1, setIsActive1] = useState(false);
    const [isActive2, setIsActive2] = useState(false);
    const [isActive3, setIsActive3] = useState(false);

    const handleClick = event => {
        // 👇️ toggle shown state
        setIsShown(current => !current);

        // 👇️ or simply set it to true
        // setIsShown(true);
    };

    const handleButtonClick1 = () => {
        setIsActive1(current => !current);
    };

    const handleButtonClick2 = () => {
        setIsActive2(current => !current);
    };

    const handleButtonClick3 = () => {
        setIsActive3(current => !current);
    };

    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div>
            <div className="map-container">
                <div className="map-insight">
                    <button
                        className="openModalBtn"
                        onClick={() => {
                            setModalOpen(true);
                        }}
                    >
                        แก้ไข
                    </button>
                    {modalOpen && <Modal setOpenModal={setModalOpen} />}

                    <div className="map-insight-title">
                        Feed Production Capacity 43 ล้านตัน
                    </div>
                    <div className="actual-production-container">
                        <div className="actual-production-bar">
                            <div className="actual-production-percent">75%</div>
                        </div>
                        <div className="actual-production-title">Actual production 33 ล้านตัน</div>
                    </div>
                    <div className="map-insight-title">
                        Production Breakdown
                    </div>
                    <div className="pie-chart-container">
                        <PiChart />
                    </div>
                    <table className="insight-table">
                        <tr>
                            <th>ประเทศ</th>
                            <th>กำลังการผลิต</th>
                            <th>ผลิตจริง</th>
                            <th>%ใช้งาน</th>
                            <th id="th-color">%ใช้เอง</th>
                            <th id="th-color">%ขายลูกค้า</th>
                        </tr>
                        <tr>
                            <td>จีน</td>
                            <td>16.6</td>
                            <td>11.4</td>
                            <td>69%</td>
                            <td>42%</td>
                            <td>58%</td>
                        </tr>
                        <tr>
                            <td>ไทย</td>
                            <td>7.1</td>
                            <td>6.0</td>
                            <td>84%</td>
                            <td>66%</td>
                            <td>34%</td>
                        </tr>
                        <tr>
                            <td>เวียดนาม</td>
                            <td>4.7</td>
                            <td>3.9</td>
                            <td>83%</td>
                            <td>68%</td>
                            <td>32%</td>
                        </tr>
                        <tr>
                            <td>อินโดนีเซีย</td>
                            <td>7.5</td>
                            <td>5.6</td>
                            <td>75%</td>
                            <td>59%</td>
                            <td>41%</td>
                        </tr>
                        <tr>
                            <td>อื่นๆ (11ประเทศ)</td>
                            <td>7.8</td>
                            <td>5.9</td>
                            <td>81%</td>
                            <td>51%</td>
                            <td>49%</td>
                        </tr>
                        <tr id="tr-color">
                            <td>รวม</td>
                            <td>43.7</td>
                            <td>32.7</td>
                            <td>75%</td>
                            <td id="th-color">55%</td>
                            <td id="th-color">45%</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    );
}

